export enum SelectorType {
  Best = 'Best',
  Random = 'Random',
  BestOrRandom = 'BestOrRandom',
  LatestOrRandom = 'LatestOrRandom'
}
